import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    showState: {
      type: Boolean,
      default: true
    },
    titleOut: {
      type: Boolean,
      default: false
    },
    width: {
      type: [String, Number],
      default: '450'
    },
    height: {
      type: [String, Number],
      default: '295'
    },
    percentHeight: {
      type: String,
      default: ''
    },
    siteName: {
      type: String,
      default: ''
    },
    top: {
      type: String,
      default: '20'
    },
    // margin-top的值
    unit: {
      type: String,
      default: 'px'
    },
    iconfont: {
      type: String,
      default: ''
    },
    background: {
      type: String,
      default: 'rgba(0,78,187,0.5)'
    },
    left: {
      type: String,
      default: '0'
    }
  }
};